import ForgotPasswordForm from '../components/Auth/ForgotPasswordForm';

const ForgotPasswordPage = () => {
  return <ForgotPasswordForm />;
};

export default ForgotPasswordPage;








